import { HttpClient, HttpParamsOptions } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { V2NODE_URL } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class V2nodeApiService {
  private _url: string;

  constructor(private http: HttpClient) {
    this._url = 'v2node/api';
  }

  requestApi({ action, method = 'GET', datas = {}, queryParams = {}, customUrl = '', httpOptions = {} }: { action: string; method?: string; datas?: any; queryParams?: any, customUrl?: string | null, httpOptions?: any }): Promise<any> {
    const methodWanted = method.toLowerCase();
    
    
    let urlToUse = '';
    if(customUrl === "") {
      urlToUse = this.url + action;
    } else {
      urlToUse = customUrl + action;
    }

    let req = null;

    if (methodWanted === 'post') {
      req = this.http.post(urlToUse, datas, {params: queryParams, ...httpOptions});
    } else if (methodWanted === 'put') {
      req = this.http.put(urlToUse, datas, {params: queryParams, ...httpOptions});
    } else if (methodWanted === 'delete') {
      req = this.http.delete(urlToUse, {params: queryParams, body: datas, ...httpOptions});
      
      
    } else {
      req = this.http.get(urlToUse, {params: queryParams, ...httpOptions});
    }

    return req.toPromise();
  }

  get url(): string {
    return this._url;
  }
}
